import React from "react";
import { observer } from "mobx-react";
import { WalletStore } from "../../stores/wallet/wallet-store";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import WalletPaymentMethodErrorIcon from "./wallet-payment-method-error-icon";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Button } from "../../../../components/inputs/button/button";
import "./wallet-payment-method-error-modal.scss";
import WalletPaymentMethodErrorTransaction from "./wallet-payment-method-error-transaction";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FailedDepositTransactionsStore from "../../stores/wallet/failed-deposit-transactions-store";

interface IProps {
    onCloseClick: () => void;
    // WalletStore is needed for addPaymentMethodHandler (Update Payment Method button)
    walletStore: WalletStore;
    failedDepositTransactionsStore: FailedDepositTransactionsStore;
}

const WalletPaymentMethodErrorModal: React.FC<IProps> = observer(({ onCloseClick, walletStore, failedDepositTransactionsStore }) => {
    return (
        <DefaultModalLayout onCloseClicked={() => onCloseClick()} isCloseDisabled={failedDepositTransactionsStore.isLoading}>
            <div className="wallet-payment-method-error-modal">
                <div className="wallet-payment-method-error-modal-content">
                    <div className="wallet-payment-method-error-modal-title">
                        <WalletPaymentMethodErrorIcon errorText={""} />
                    </div>
                    <div className="wallet-payment-method-error-modal-text">
                        <FontBody1 variant={FONT_VARIANT.BOLD}>{"Payment Failed"}</FontBody1>
                        <FontBody1>{`Your payment of ${failedDepositTransactionsStore.amountFormattedWithCurrencySymbol} using ${failedDepositTransactionsStore.paymentCardBrand} ****${failedDepositTransactionsStore.paymentCardLast4} couldn't be completed. Here's what happened:`}</FontBody1>
                    </div>
                </div>
                {failedDepositTransactionsStore.transactions.length > 0 && (
                    <div className="wallet-payment-method-error-modal-transactions">
                        {failedDepositTransactionsStore.transactions.map((transaction, index) => (
                            <WalletPaymentMethodErrorTransaction key={index} attemptIndex={index + 1} transaction={transaction} />
                        ))}
                    </div>
                )}
                <div className="wallet-payment-method-error-modal-details">
                    <FontBody1>{"You won't be able to add any more credits to your wallet until your payment method is updated."}</FontBody1>
                </div>
                <div className="wallet-payment-method-error-modal-buttons">
                    <Button
                        variant={BUTTON_VARIANTS.Tertiary}
                        isLoading={failedDepositTransactionsStore.isRetryingLastDeposit}
                        hasLoader={true}
                        text="Try Again"
                        onClick={failedDepositTransactionsStore.retryLastDepositHandler}
                    />
                    <Button
                        variant={BUTTON_VARIANTS.Primary}
                        isLoading={walletStore.isAddingPaymentMethod}
                        hasLoader={true}
                        text="Update Payment Method"
                        onClick={walletStore.addPaymentMethodHandler}
                    />
                </div>
            </div>
        </DefaultModalLayout>
    );
});

export default WalletPaymentMethodErrorModal;